import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"
import { cn } from "src/common/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1.5 [&>svg]:pointer-events-none transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "bg-primary/15 text-primary border-primary/20",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",

        // Status badges
        orange: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/20",
        red: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/20",
        coral: "bg-red-500/15 text-red-700 dark:text-red-400 border-red-500/20",
        green: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border-emerald-500/20",
        slate: "bg-muted-foreground/10 text-muted-foreground border-muted-foreground/30",
        blue: "bg-blue-500/15 text-blue-700 dark:text-blue-400 border-blue-500/20",
        amber: "bg-amber-500/15 text-amber-700 dark:text-amber-400 border-amber-500/20",
      },
      size: {
        xs: "",
        sm: "px-3 py-1 text-sm",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "xs",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  size?: "xs" | "sm";
}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
